import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetSalesResponse {
    member_idx: number;
    customer_idx: number;
    customer_name: string;
    order_name: string;
    order_mobile: string;
    current_amount: number;
    pending_amount: number;
}

export const useGetSalesInfo = (
    customerIdx: number,
    orderIdx: number,
    startDate?: Date,
    endDate?: Date,
    search?: string,
    searchtxt?: string,
    selectedOrders?: number[],
): UseQueryResult<GetSalesResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    const trimmedSearchTxt = searchtxt?.trim() ?? "";
    const orderIdxListParam = selectedOrders && selectedOrders.length > 0 ? selectedOrders.join(",") : undefined;

    return useQuery<GetSalesResponse, Error>({
        queryKey: [
            "getSalesInfo",
            customerIdx,
            orderIdx,
            startDate?.toISOString(),
            endDate?.toISOString(),
            search,
            trimmedSearchTxt,
            orderIdxListParam,
        ],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_sales_info.replace(":customer_idx", customerIdx.toString())}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    order_idx: orderIdx === 0 ? null : orderIdx,
                    start_date: startDate ? startDate.toISOString().split("T")[0] : undefined,
                    end_date: endDate ? endDate.toISOString().split("T")[0] : undefined,
                    search: trimmedSearchTxt ? search : undefined,
                    searchtxt: trimmedSearchTxt || undefined,
                    order_idx_list: orderIdxListParam,
                },
            });
            return response.data.data;
        },
        enabled: !!customerIdx, // 필요한 경우 조정
        placeholderData: prevData => prevData,
    });
};
